import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { PositionType, TYPES } from '@antv/l7-core';
import { DOM } from '@antv/l7-utils';
import { EventEmitter } from 'eventemitter3';
export { PositionType } from '@antv/l7-core';
var controlId = 0;

var Control = function (_EventEmitter) {
  _inherits(Control, _EventEmitter);

  var _super = _createSuper(Control);

  function Control(cfg) {
    var _this;

    _classCallCheck(this, Control);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "controlOption", void 0);

    _defineProperty(_assertThisInitialized(_this), "container", void 0);

    _defineProperty(_assertThisInitialized(_this), "sceneContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "mapsService", void 0);

    _defineProperty(_assertThisInitialized(_this), "renderService", void 0);

    _defineProperty(_assertThisInitialized(_this), "layerService", void 0);

    _defineProperty(_assertThisInitialized(_this), "controlService", void 0);

    _defineProperty(_assertThisInitialized(_this), "isShow", void 0);

    _this.controlOption = _objectSpread(_objectSpread({}, _this.getDefault()), cfg || {});
    return _this;
  }

  _createClass(Control, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        position: PositionType.TOPRIGHT,
        name: "".concat(controlId++)
      };
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PositionType.BOTTOMRIGHT;
      var controlService = this.controlService;

      if (controlService) {
        controlService.removeControl(this);
      }

      this.controlOption.position = position;

      if (controlService) {
        controlService.addControl(this, this.sceneContainer);
      }

      return this;
    }
  }, {
    key: "addTo",
    value: function addTo(sceneContainer) {
      this.mapsService = sceneContainer.get(TYPES.IMapService);
      this.renderService = sceneContainer.get(TYPES.IRendererService);
      this.layerService = sceneContainer.get(TYPES.ILayerService);
      this.controlService = sceneContainer.get(TYPES.IControlService);
      this.sceneContainer = sceneContainer;
      this.isShow = true;
      this.container = this.onAdd();
      var container = this.container;
      var pos = this.controlOption.position;
      var corner = this.controlService.controlCorners[pos];
      DOM.addClass(container, 'l7-control');

      if (pos.indexOf('bottom') !== -1) {
        corner.insertBefore(container, corner.firstChild);
      } else {
        corner.appendChild(container);
      }

      return this;
    }
  }, {
    key: "onAdd",
    value: function onAdd() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "onRemove",
    value: function onRemove() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "hide",
    value: function hide() {
      var container = this.container;
      DOM.addClass(container, 'l7-control-hide');
      this.isShow = false;
    }
  }, {
    key: "show",
    value: function show() {
      var container = this.container;
      DOM.removeClass(container, 'l7-control-hide');
      this.isShow = true;
    }
  }, {
    key: "remove",
    value: function remove() {
      if (!this.mapsService) {
        return this;
      }

      DOM.remove(this.container);
      this.onRemove();
    }
  }, {
    key: "_refocusOnMap",
    value: function _refocusOnMap(e) {
      if (this.mapsService && e && e.screenX > 0 && e.screenY > 0) {
        var container = this.mapsService.getContainer();

        if (container !== null) {
          container.focus();
        }
      }
    }
  }]);

  return Control;
}(EventEmitter);

export { Control as default };
//# sourceMappingURL=BaseControl.js.map